<template lang="html">
    <flag :iso="getFlag" style="height:20px; width:20px; border-radius:50%; margin-right: 5px;"/>
</template>

<script>
import utils from "@/utils.js";

export default {
  name: "MyFlag",
  props: {
    lang: String
  },
  computed: {
    getFlag() {
      return utils.languageMapping(this.lang);
    }
  }
};
</script>

